module.exports = __webpack_public_path__ + "static/media/about-column2.30a20821.png";